// *******~ Import ~******** //
// React
// Assets
import { lazy } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// Components
import GoTop from "./common/gototop/gototop";
import ScrollToTop from "./common/scrolltop/scrolltop";
import Routing from "./router/router";
// import Header from "./common/header/header";
import Header from "./common/header/header/HeaderRes";
import { OrderFlow } from "./App";
const Footer = lazy(() => import("./common/footer/footer"));
// CSS
// Images
// Icons
// *******~ Import ~******** //

const Main = (params) => {
  const { menuFooter } = OrderFlow();
  
  return (
    <>
      <GoTop />
      <ScrollToTop />
      <Header />
      <Routing stripe={params.stripe} />
      {menuFooter && <Footer />}
      {/* {footerLoading ? <Footer /> : null} */}
      {/* <FeedBack /> */}
    </>
  );
};

export default Main;
